import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Accordion } from '@reach/accordion';
import { tokens, Text } from '@hotjar/hotsauce';
import { ScoreInfoSection } from './ScoreInfoSection';
import { BenefitsSection } from './BenefitsSection';

const Title = styled(Text)`
  display: block;
  padding: ${tokens.spacer.x3} ${tokens.spacer.x3} ${tokens.spacer.x1};
`;

const Description = styled.div`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
`;

// An embedded feedback widget will be loaded inside this container.
// By default the feedback widget has a lot of white space around it that doesn't
// fit the designs. We are overcoming this by adjusting margin top and bottom.
// To make sure that everything renders correctly even without the feedback
// widget, we need to apply a min-height that cancels out the margin adjustments.
const FeedbackContainer = styled.div`
  margin-top: -32px;
  margin-bottom: -42px;
  min-height: 74px;
`;

export const EngagementSecondaryView = (): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  return (
    <>
      <Title as="span" textType="subtitle2">
        {t('smart-panel.engagement-zones.help.description.title')}
      </Title>
      <Description>
        <Text as="span" textType="body2">
          {t('smart-panel.engagement-zones.help.description.text-1')}
          <br />
          <br />
          {t('smart-panel.engagement-zones.help.description.text-2')}
        </Text>
      </Description>
      <Accordion defaultIndex={[0, 1]} multiple>
        <BenefitsSection />
        <FeedbackContainer id="heatmap-engagement-feedback" />
        <ScoreInfoSection />
      </Accordion>
    </>
  );
};
